/*jshint esversion: 6 */
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import * as dataCombiner from "./utils/DataCombiner.js";
import PageProxy from './Components/PageProxy.js';
import PageDisplayer from './Components/PageDisplayer';

class AppRoutes extends Component {

  constructor(props){
    super(props);
    this.state = {
      pageObjects: [],
      isMobileToggleOn: false
    };
    this.getRoutes = this.getRoutes.bind(this);
   
  }

  getRoutes(pageObjects){
    let pagetitles = this.props.pagetitles.slice();
    let pageObjectsCopy = pageObjects.slice();
    //console.log('AppRoutes getRoutes ', pagetitles);
    var pages = [];
    pagetitles.map((pt, kt) => {
      let pageTitle = pt.parent;
      let subPages = pt.subpages;
      pageObjects.map((po, k) => {
        //include pageobject subpages
        if(po.subpages.length){
          po.subPageObjects = pageObjectsCopy.filter(subpo => po.subpages.includes(subpo._id));
        }
        //console.log('getRoutes po',po);
        if(po.pagetitle.toLowerCase() === pageTitle.toLowerCase()){
          if(po.isAvaleht){
            pages.push(
              (<Route key = {k} 
                  exact path='/' 
                  component={PageProxy(po, pagetitles)(PageDisplayer)} />)
            );
          }

          pages.push(
              (<Route key = {k} 
                  exact path={pt.link} 
                  component={PageProxy(po, pagetitles)(PageDisplayer)} />)
          );
        }
      });//pageObjects.map

      //console.log('AppRoutes subPages ', subPages);
      if(subPages.length){
        subPages.map((sub, skt) => {
          pageObjects.map((po, k) => {
            if(po.pagetitle.toLowerCase() === sub.title.toLowerCase()){
              let subPageRoute = sub.link;
              //console.log('subPageRoute', subPageRoute);
              pages.push(
                  (<Route key = {k} 
                      path={subPageRoute} 
                      component={PageProxy(po)(PageDisplayer)} />)
              );
            }
          });//pageObjects.map
        });//subPages.map
      }//if(subPages.length)

    });//pagetitles.map
    return pages;
  }


    render() {
      let pageObjects = this.props.pageObjects.slice();
      //get all related data organized
      dataCombiner.getPageParagraphs(pageObjects, this.props.paragraphs, this.props.manuses, this.props.templates);
       
      //let pagetitles = this.props.pagetitles.slice();

      // let templates = this.props.templates.slice();
      // let paragraphs = this.props.paragraphs.slice();
      // let manuses = this.props.manuses.slice();
      // console.log('RENDER AppRoutes templates: ', templates);
      // console.log('RENDER AppRoutes pagetitles: ', pagetitles);
      // console.log('RENDER AppRoutes paragraphs: ', paragraphs);
      // console.log('RENDER AppRoutes manuses: ', manuses);
      /*
      //separately get home-page object Route
      let avalehtPageObject = pageObjects.filter(po => po.isAvaleht);
      if(avalehtPageObject.length){
        avalehtPageObject = avalehtPageObject[0];
      }
      //console.log('RENDER AppRoutes avalehtPageObject: ', avalehtPageObject);
      const Avaleht = PageProxy(avalehtPageObject, this.props.pagetitles);
      */
      return (
        <Switch>
            {this.getRoutes(pageObjects)}
        </Switch>
      );
    }
  }
  
  export default AppRoutes;


// WEBPACK FOOTER //
// ./src/AppRoutes.js